import React, { useEffect, useState } from "react";
import Accuracy_table from "./accuracy_table/Accuracy_table";
import Accuracy_Form from "./accuracy_Form/Accuracy_Form";
import { GetAll } from "../../../../../../../../src/features/admin/quality_management/process_requirement/accuracy/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Accuracy() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const accuracydetails = useSelector((state) => state.accuracy);

  const permissions = useSelector((state) => state.auth.permissions);
                                  
  const haveReadPermission = permissions?.includes(FixIDS.accuracy.List);
  const haveAddPermission = permissions?.includes(FixIDS.accuracy.Add); //form

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: accuracydetails?.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  
  const [showTable, setShowTable] = useState(false);
  return (
    <>
      <div className="imperiality_Form_div">
        { haveAddPermission && <Accuracy_Form onProceed={() => setShowTable(true)} />}
      </div>

      {/* {showTable && ( */}
      <div className="imperiality_table_div">
        { haveReadPermission && <Accuracy_table
          accuracydetails={accuracydetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          fetchCustomers={fetchCustomers}
        /> }
      </div>
      {/* )} */}
    </>
  );
}

export default Accuracy;
